module.exports = __webpack_public_path__ + "static/media/logo-lartech.5566c431.svg";